export default __webpack_public_path__ + "static/media/info-journey.f1444005.gif";